/* eslint-disable camelcase */
import {
    GET_OBJECT_SELECTED,
    UPDATE_OBJECT_SELECTED,
} from '../action/actionTypes';

const initialState = {
    loggedUser: {
        has_integrations: null,
        loadingHasIntegration: true,
        is_legacy: false,
        timer: {},
    },
    objectSelected: {
        account_selected: null,
        client_selected: null,
        loadingObjectSelected: true,
        currencySymbolSelected: null,
    },
};


const isAccountSelected = ({
    account_selected: accountSelected = 'all',
} = {}) => (
    accountSelected === 'all' || (accountSelected && accountSelected.selected)
);

function getCurrencyForObjectSelected({ client_selected, account_selected }) {
    if (!client_selected || !account_selected) {
        return null;
    }
    return client_selected.currency_symbol === '' ? account_selected.currency_symbol : client_selected.currency_symbol;
}

const getObjectSelected = (state, action) => ({
    ...state,
    objectSelected: {
        ...action.objectSelected,
        loadingObjectSelected: false,
        isAccountSelected: isAccountSelected(action.objectSelected || {}),
        currencySymbolSelected: getCurrencyForObjectSelected(action.objectSelected || {}),
    },
});

const getObjectNames = (data) => {
    let selectedName = '';
    let notSelectedName = '';
    const isAccount = data.type === 'account';

    if (isAccount) {
        selectedName = 'account_selected';
        notSelectedName = 'client_selected';
    } else {
        selectedName = 'client_selected';
        notSelectedName = 'account_selected';
    }

    return { selectedName, notSelectedName };
};

const updateObjectSelected = (state, action) => {
    const { objectSelected } = state;
    const { objectSelected: objectSelectedAction } = action;
    const { label, data } = objectSelectedAction;

    const { selectedName, notSelectedName } = getObjectNames(data);
    const nextObjectSelected = {
        [notSelectedName]: {
            ...objectSelectedAction[notSelectedName],
            selected: false,
        },
        [selectedName]: {
            ...objectSelected[selectedName],
            content_type: data.type_id,
            id: data.id,
            name: label,
            selected: true,
            content_type_name: data.ad_account ? data.ad_account.type : data.type,
            is_mocked: data.is_mocked,
            shared: data.shared,
        },
    };

    return {
        ...state,
        objectSelected: {
            ...nextObjectSelected,
            loadingObjectSelected: false,
            isAccountSelected: isAccountSelected(nextObjectSelected),
        },
    };
};


const paretoAdsAppReducer = (state = initialState, action) => {
    switch (action.type) {
    case GET_OBJECT_SELECTED:
        return getObjectSelected(state, action);
    case UPDATE_OBJECT_SELECTED:
        return updateObjectSelected(state, action);
    default:
        return state;
    }
};

export default paretoAdsAppReducer;
